import wrapPromise from './wrapPromise'

function fetchData(url, transform = res => res.json()) {
    const promise = fetch(url).then(transform)
    return wrapPromise(promise)
}

export default fetchData